import { render, staticRenderFns } from "./restaurant_notification.vue?vue&type=template&id=6658e09c&scoped=true&"
import script from "./restaurant_notification.vue?vue&type=script&lang=js&"
export * from "./restaurant_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658e09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6658e09c')) {
      api.createRecord('6658e09c', component.options)
    } else {
      api.reload('6658e09c', component.options)
    }
    module.hot.accept("./restaurant_notification.vue?vue&type=template&id=6658e09c&scoped=true&", function () {
      api.rerender('6658e09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/restaurant_notification.vue"
export default component.exports